import {
  laptopMax,
  laptopMediumMax,
  laptopSmallMax,
  tabletMax,
  tabletMin,
} from '@propertypal/shared/src/constants/mediaQueries';
import ContactGraphicPN from '@propertypal/shared/src/resources/bg/contact-graphic-pn.svg';
import ContactGraphic from '@propertypal/shared/src/resources/bg/contact-graphic.svg';
import { hexToRgb } from '@propertypal/shared/src/utils/colour';
import platform from '@propertypal/shared/src/utils/platform';
import styled, { css } from 'styled-components';
import { Text } from '../typography';

export const FaqContactContainer = styled.div`
  width: 100%;
  border-radius: 8px;
  margin-top: 40px;
  background-color: ${platform.select('#f9d5c6', '#ffdae2')};
`;

export const FaqContactWrapper = styled.div`
  padding: 15px;
  padding-bottom: 0px;
  max-width: 1140px;
  margin: 0 auto;
  position: relative;
  display: flex;
  gap: 10px;
  align-items: center;
  overflow: hidden;

  @media (${tabletMax}) {
    flex-direction: column;
    gap: 25px;
    padding-top: 25px;
  }

  @media (${tabletMin}) {
    min-height: 270px;
  }
`;

export const FaqContactContent = styled.div`
  flex: 1;

  ${platform.select(
    css``,
    css`
      @media (${laptopMediumMax}) {
        ${Text}:first-of-type {
          font-size: 24px;
        }
        ${Text}:nth-of-type(2) {
          font-size: 17px;
        }
      }
    `,
  )}

  @media (${tabletMax}) {
    text-align: center;
  }
`;

export const FaqBg = styled(ContactGraphic)`
  display: block;

  @media (max-width: 1180px) and (${tabletMin}) {
    width: 530px;
  }
  @media (${laptopMax}) and (${tabletMin}) {
    width: 450px;
  }
  @media (${tabletMin}) {
    align-self: flex-end;
    width: 663px;
  }
`;

export const FaqBgPn = styled(ContactGraphicPN)`
  display: block;
  scale: 1.3;
  padding-top: 30px;

  @media (${tabletMin}) {
    align-self: flex-end;
    padding-top: 0px;
    height: 220px;
    scale: 1.3;
  }

  @media (${laptopSmallMax}) and (${tabletMin}) {
    width: 325px;
  }
`;

export const ButtonLink = styled.button`
  background-color: ${({ theme }) => theme.primary};
  border-radius: 4px;
  padding: 16px 10px;
  color: ${({ theme }) => theme.white};
  font-weight: bold;
  font-size: 16px;
  width: 240px;
  transition: background-color 0.4s ease 0s;

  &:hover {
    background-color: ${({ theme }) => hexToRgb(theme.primary, 1, -55)};
  }
`;
